import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { getCapabilities, type Capabilities } from "../api/capabilities.js";
import { useApiClient } from "../api/ApiClientContext.js";

export function useCapabilities(): UseQueryResult<Capabilities> {
  const client = useApiClient();
  return useQuery({
    queryKey: ["capabilities"],
    queryFn: () => getCapabilities(client),
    // This almost never changes for a running deployment (it is derived from
    // which storage dialect the server was started against) — no need to
    // ever refetch it in the background.
    staleTime: Infinity,
  });
}
